import React from 'react';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';
import { Event } from './types';
import Text from '../text/Text';
import EventItem from './EventItem';

const GenerateDay = ({
  i,
  isSelected,
  disabled,
  isToday,
  displayDate,
  activeId,
  setActiveId,
  events,
  eventCard,
  loading,
}: {
  i: number;
  isSelected: boolean;
  disabled: boolean;
  isToday: boolean;
  displayDate: Dayjs;
  activeId: string | number;
  setActiveId: (id: string | number) => void;
  events: Event[];
  eventCard?: (data: Event) => React.JSX.Element;
  loading?: boolean;
}) => {
  const currentDate = dayjs(
    new Date(dayjs(displayDate).year(), dayjs(displayDate).month(), i),
  );

  const currentDateEvents = events?.filter((event) =>
    dayjs(event.date).isSame(currentDate),
  );

  return (
    <div
      key={`day-${i}`}
      className={classNames('border scrollbar', {
        'bg-primary-midlight': isSelected,
        'bg-danger': isToday,
        skeleton: loading,
      })}
      style={{ height: '150px' }}
    >
      <Text
        size="md"
        className={classNames('text-center p-5', {
          'text-white': isToday,
          'opacity-25': disabled,
        })}
      >
        {i}
      </Text>

      {currentDateEvents?.length > 0 ? (
        <div className="overflow-auto" style={{ height: '120px' }}>
          {currentDateEvents?.map((event, idx) => {
            return (
              <EventItem
                key={event.id}
                event={event}
                activeId={activeId}
                setActiveId={setActiveId}
                idx={idx}
                eventCard={eventCard}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default GenerateDay;
